import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { X } from "lucide-react";

interface CommentPopoverProps {
  position: { top: number; left: number };
  dotPosition: { x: number; y: number };
  onPost: (positionX: number, positionY: number, content: string) => void;
  onClose: () => void;
}

const CommentPopover = ({ position, dotPosition, onPost, onClose }: CommentPopoverProps) => {
  const [comment, setComment] = useState("");

  const handlePost = () => {
    if (comment.trim()) {
      onPost(dotPosition.x, dotPosition.y, comment.trim());
      setComment("");
      onClose();
    }
  };

  return (
    <div
      className="fixed z-50 w-80 bg-card rounded-lg border border-foreground/10 shadow-xl animate-in fade-in-0 zoom-in-95"
      style={{
        top: position.top,
        left: position.left,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-foreground/10">
        <span className="text-sm font-medium text-foreground">Add Comment</span>
        <button
          onClick={onClose}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        <Textarea
          placeholder="Write your comment..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="min-h-[100px] resize-none"
          autoFocus
        />

        {/* Actions */}
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="default"
            size="sm"
            onClick={handlePost}
            disabled={!comment.trim()}
            className="bg-foreground text-primary-foreground hover:bg-accent hover:text-accent-foreground"
          >
            Post Comment
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CommentPopover;
